export default __webpack_public_path__ + "static/media/avatar.71eb70d0.png";